import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  to?: string;
  target?: string;
  download?: string | boolean;
}

interface Emits {
  (e: 'click'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiLink',
  props: {
    to: { default: undefined },
    target: { default: undefined },
    download: { type: [String, Boolean], default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { to: string, target: string, download: string | boolean };





const isExternalLink = computed(() => /^https?:/.test(props.to ?? ''));
const isSamePageLink = computed(() => props.to?.startsWith('#'));

const isNativeLink = computed(
  () => isExternalLink.value || isSamePageLink.value,
);

const linkTarget = computed(() =>
  props.target ?? isExternalLink.value ? '_blank' : '_self',
);

const onLinkClick = (e: MouseEvent) => {
  if (isSamePageLink.value) {
    e.preventDefault();
    if (props.to)
      document?.querySelector(props.to)?.scrollIntoView({
        behavior: 'smooth',
      });
  }

  emit('click');
};

const onRouterLinkClick = (
  e: MouseEvent,
  navigate: (event: MouseEvent) => void,
) => {
  navigate(e);
  onLinkClick(e);
};

return { __sfc: true,props, emit, isExternalLink, isSamePageLink, isNativeLink, linkTarget, onLinkClick, onRouterLinkClick }
}

})